module.exports = __webpack_public_path__ + "img/hot-tub.5a4a7ef3.svg";